// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import injectCss from "@insite/mobius/utilities/injectCss";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import * as React from "react";
import styled, { css } from "styled-components";
import { getStatusColorTheme, StatusColorTheme } from "@store/Library/Components/statusColorMaps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

interface StyledBadgeSpanProps extends InjectableCss {
    backgroundColorToken: string;
    borderColorToken: string;
    textColorToken: string;
}

const StyledBadgeSpan = styled.span<StyledBadgeSpanProps>`
    background-color: ${props => getColor(props.backgroundColorToken)(props)};
    border: 1px solid ${props => getColor(props.borderColorToken)(props)};
    color: ${props => getColor(props.textColorToken)(props)};
    ${injectCss}
`;

export interface StatusBadgePresentationProps extends ExpandStyles<StatusBadgeStyles> {}

export interface StatusBadgeStyles {
    wrapper?: InjectableCss;
}

export const statusBadgeStyles: StatusBadgeStyles = {
    wrapper: {
        css: css`
            display: inline-block;
            border-radius: 2px;
            padding: ${pxToRem(1)} ${pxToRem(6)};
            font-weight: 500;
            font-size: ${pxToRem(14)};
            line-height: 1.4;
            white-space: nowrap;
            overflow: hidden;
        `,
    },
};

interface StatusBadgeProps extends StatusBadgePresentationProps {
    /** Raw status key used to look up the color theme */
    status: string | undefined | null;
    /** The translated display text shown inside the badge */
    displayText: string;
    /** Color map to use for theme lookup (orderStatusColorMap or shipmentStatusColorMap) */
    colorMap: Record<string, StatusColorTheme>;
    /** Optional icon rendered inline inside the badge */
    icon?: React.ReactNode;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({
    status,
    displayText,
    colorMap,
    icon,
    extendedStyles,
    overridedStyles,
}) => {
    const colorTheme = getStatusColorTheme(status, colorMap);
    const styles = useExpandProps(statusBadgeStyles, extendedStyles, overridedStyles);

    return (
        <StyledBadgeSpan
            {...styles.wrapper}
            backgroundColorToken={colorTheme.backgroundColorToken}
            borderColorToken={colorTheme.borderColorToken}
            textColorToken={colorTheme.textColorToken}
        >
            {displayText}
            {icon}
        </StyledBadgeSpan>
    );
};

export default StatusBadge;
